export enum hotCallStatus {
    Open = 'Open',
    Accepted = 'Accepted',
    Picked = 'Picked',
    ActionNeeded = 'Action Needed',
    PartUnAvailable = 'Part Unavailable',
    Closed = 'Closed'
}

export enum apiEndPoints {
    GetAdrConfig = '/adr/get-adr-config',
    GetPartsByKanban = '/parts/get-part-by-kanban',
    GetSingleParts = '/parts/get-single-part-details',
    GetPlanLineByKanban = '/lineside/get-plant-line-by-kanban',
    GetRunOutInformation = '/lineside/get-run-out-info',
    GetVehicleDetails = '/galc/get-vehicle-details',
    GetFirstSequenceNumber = '/galc/get-first-seqno-by-plantcode'
}

export enum apiQueryParams {
    kanban = 'kanban',
    business_entity = 'business_entity',
    PartNo = 'part_no',
    PlantName = 'plant_name',
    ShopName = 'shop_name',
    LineName = 'line_name',
    SingleKanban = 'kanban',
    kanbanCode = 'kanban_code',
    lineSideAddress = 'lineside_address',
    supplierCode = 'supplier_code',
    dockCode = 'dock_code',
    currentBodyNumber = 'current_body_number',
    numberOfPieces = 'number_of_pieces',
    numberOfBoxes = 'number_of_boxes',
    percentageOfBox = 'percent_of_box',
    trackingID = 'tracking_point_id',
    bodyNumber = 'body_number',
    sequenceNumber = 'sequence_number'
}

export enum hotCallStatusCode {
    PotentialShortage = 0,
    Open = 1,
    Accepted = 2,
    Picked = 3,
    POEvaluation = 4,
    PartUnavailable = 5,
    ActionNeeded = 6,
    Cancelled = 7,
    Closed = 8
}